import { FunctionComponent, useContext } from "react";
import styled from 'styled-components';
import { AppContext } from "../context/AppContext";
import NavigationBar from "carbon-react/lib/components/navigation-bar";
import VerticalDivider from "carbon-react/lib/components/vertical-divider";

const AppHeaderImg = styled.img`
    margin-top: .2rem;
    height: 1.3rem;
    width: auto;
`;

const AppHeaderTitle = styled.span`
    font-weight: 700;
`;

const StickyNavigationBar = styled(NavigationBar)`
    position: sticky;
    top: 0;
    z-index: 10;
`

export const AppHeader: FunctionComponent = () => {
    const { options } = useContext(AppContext);
    if (!options.showHeader) {
        return null;
    }
    return <StickyNavigationBar navigationType="black" position="sticky">
         <AppHeaderImg alt="Sage" src="/wh-release-notes/images/logo-image.svg"/>
        <VerticalDivider displayInline/>
        <AppHeaderTitle>{options.productName}</AppHeaderTitle>
    </StickyNavigationBar>
}
